// extracted by mini-css-extract-plugin
export default {"container":"Politicas_container__FfRrT","textTitulo":"Politicas_textTitulo__Yud-M","textContainer":"Politicas_textContainer__+-Z2o","text":"Politicas_text__Becp2"};